import { Card, Form, Input } from 'antd';
import { EditLayout } from '../../../components/layout/layout/EditLayout';
import { IEcommerceDivision } from 'interfaces/ecommerce_divisions';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { SalesIconComponent } from 'assets/icons/sales';
import { useForm } from '@refinedev/antd';
import { useParams } from 'react-router-dom';

export const EcommerceDivisionEdit = () => {
  const { id } = useParams();

  const { formProps, saveButtonProps, queryResult } =
    useForm<IEcommerceDivision>({
      resource: 'ecommerce/divisions',
      id,
      redirect: false
    });

  const data = queryResult?.data?.data;

  return (
    <EditLayout saveButtonProps={saveButtonProps}>
      <PageHeader title="Editar Divisão" icon={SalesIconComponent} />
      <Card>
        <Form
          {...formProps}
          initialValues={data}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          layout="horizontal"
          style={{ maxWidth: 600 }}
        >
          <Form.Item
            label="Código"
            name="code"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
